var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6901 3C30.5351 3.525 29.2901 3.87 28.0001 4.035C29.3201 3.24 30.3401 1.98 30.8201 0.465C29.5751 1.215 28.1951 1.74 26.7401 2.04C25.5551 0.75 23.8901 0 22.0001 0C18.4751 0 15.5951 2.88 15.5951 6.435C15.5951 6.945 15.6551 7.44 15.7601 7.905C10.4201 7.635 5.66506 5.07 2.50006 1.185C1.94506 2.13 1.63006 3.24 1.63006 4.41C1.63006 6.645 2.75506 8.625 4.49506 9.75C3.43006 9.75 2.44006 9.45 1.57006 9V9.045C1.57006 12.165 3.79006 14.775 6.73006 15.36C5.78615 15.6183 4.7952 15.6543 3.83506 15.465C4.24247 16.7437 5.04036 17.8626 6.11658 18.6644C7.1928 19.4662 8.49323 19.9105 9.83506 19.935C7.5605 21.7357 4.74105 22.709 1.84006 22.695C1.33006 22.695 0.820059 22.665 0.310059 22.605C3.16006 24.435 6.55006 25.5 10.1801 25.5C22.0001 25.5 28.4951 15.69 28.4951 7.185C28.4951 6.9 28.4951 6.63 28.4801 6.345C29.7401 5.445 30.8201 4.305 31.6901 3Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6f51e69bb9df331fdf03206ad7c197e0.svg";
export { ForwardRef as ReactComponent };